"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service for notifying pin state's change
 *
 * Created by Hayk.Andriasyan on 10/16/2017.
 */
var PinUnpinService = /** @class */ (function () {
    function PinUnpinService() {
    }
    return PinUnpinService;
}());
exports.PinUnpinService = PinUnpinService;
//# sourceMappingURL=pin-unpin.service.js.map